import React, { Fragment, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { isEmail } from 'validator';
import axios from '../../config/axios-config';

import userViolationList from '../../config/locales/report-form/user';
import lectureAssignmentViolationList from '../../config/locales/report-form/lecture-assigment';
import chatViolationList from '../../config/locales/report-form/chat';

import DividerDialog from '../Dialogs/DividerDialog';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

const ReportForm = ({ lang, open, reportType = 'bug', id, unset }) => {
  const [openSuccess, setOpenSuccess] = useState(false);
  const [value, setValue] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [description, setDescription] = useState('');
  const [descriptionError, setDescriptionError] = useState(false);
  let violationOptions = [];
  let error;

  useEffect(() => {
    return () => {
      setValue('');
      setEmail('');
      setDescription('');
    };
  }, []);

  if (reportType === 'user') {
    violationOptions = userViolationList[lang];
  } else if (
    reportType === 'lecture' ||
    reportType === 'assignment' ||
    reportType === 'classroom'
  ) {
    violationOptions = lectureAssignmentViolationList[lang];
  } else if (reportType === 'chat') {
    violationOptions = chatViolationList[lang];
  }

  const handleClose = (element) => {
    if (element === 'button') {
      if (!isEmail(email)) {
        error = true;
        setEmailError(true);
      }

      if (description.trim().length === 0 && value === 'smth') {
        error = true;
        setDescriptionError(true);
      }

      if (!error) {
        axios.post('/submit/report', {
          id,
          reportType,
          violation: value ? value : violationOptions[0].violation,
          email,
          description,
        });
        setTimeout(() => {
          setOpenSuccess(true);
        }, 1000);
        setEmail('');
        setDescription('');
        setValue('');
        unset();
      }
    } else {
      unset();
    }
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSuccess(false);
  };

  const formContent = (
    <Fragment>
      <TextField
        id='standard-select-form-report'
        select
        label={<FormattedMessage id='report-form.violation-label' />}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        SelectProps={{
          native: true,
        }}
        helperText={<FormattedMessage id='report-form.helper-text-violation' />}
        fullWidth
      >
        {violationOptions.map((option) => (
          <option key={option.label} value={option.label}>
            {option.violation}
          </option>
        ))}
      </TextField>
      <TextField
        required
        id='contact-email'
        label={<FormattedMessage id='report-form.email-label' />}
        error={emailError}
        style={{ margin: '1rem 0' }}
        value={email}
        onChange={(e) => {
          if (emailError) setEmailError(false);
          setEmail(e.target.value);
        }}
        variant='filled'
        helperText={
          emailError ? <FormattedMessage id='report-form.helper-text-email' /> : ''
        }
        fullWidth
      />
      <TextField
        id='filled-multiline-flexible'
        required={value === 'smth'}
        label={<FormattedMessage id='report-form.description-label' />}
        error={descriptionError}
        helperText={
          descriptionError ? (
            <FormattedMessage id='report-form.helper-text-description' />
          ) : (
            ''
          )
        }
        multiline
        fullWidth
        rows={4}
        value={description}
        onChange={(e) => {
          if (descriptionError) setDescriptionError(false);
          setDescription(e.target.value);
        }}
        variant='filled'
      />
    </Fragment>
  );

  return (
    <Fragment>
      <DividerDialog
        open={open}
        handleClose={(element) => handleClose(element)}
        dialogTitle={<FormattedMessage id={`report-form.${reportType}-dialog-title`} />}
        dialogContent={formContent}
        buttonText={<FormattedMessage id='report-form.button' />}
      />
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleSuccessClose}>
        <Alert onClose={handleSuccessClose} severity='success'>
          <FormattedMessage id='report-form.submit-success' />
        </Alert>
      </Snackbar>
    </Fragment>
  );
};

export default ReportForm;
